export function getError(error) {
	if (error.response)
		if (error.response.status == 429 && error.response.headers['retry-after'])
			return 'Try again later';
		else 
		{	
			if(error.response.status == 401)
				return "عذراً، فشلت عملية تسجيل الدخول الرجاء التأكد من اسم المُستخدم وكلمة المرور."
			if(error.response.status >= 500)
				return 'حدث خطأ من جانب المُخدِم.'
			else
				return error.response.data.Message
		} 
	else {
		if (!window.navigator.onLine){
			return 'تحقق من اتصالك بالإنترنت';
		}
		else {
			return 'Network error';
		}
	}
}

export function getDetailedError(error) {
	if (error.response) {
		if (error.response.status >= 400 && error.response.status < 600) {
			return error.response.data.ExceptionMessage || error.response.data.title || error.response.data;
		}
		else if (error.response.status >= 500)
			return 'حدث خطأ من جانب المُخدِم.';
	}
	else {
		if (!window.navigator.onLine){
			return 'تحقق من اتصالك بالإنترنت';
		}
		else {
			return 'Network error';
		}
	}
}